import React, { useEffect } from 'react';
import './About.css';
import { motion } from 'framer-motion';
import Header from '../../Shared/Header/Header';
import Footer from '../../Shared/Footer/Footer';
import ProfileImage from '../../../img/profile_img.PNG';
import ExperienceCard from '../../../components/ExperienceCard';
import { useApp } from '../../../contexts/AppContext';

const About = () => {
  const { isInitialLoad, setIsInitialLoad } = useApp();

  useEffect(() => {
    if (isInitialLoad) return;
    setIsInitialLoad(true);
  }, [isInitialLoad, setIsInitialLoad]);

  return (
    <>
      <Header></Header>
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 2 }}
        className='card my-5 mx-auto shadow'
        style={{ width: '90%', borderRadius: '5px' }}
      >
        <div className='row g-3'>
          <div className='col-md-4 d-flex justify-content-center align-items-center'>
            {/* <img
              src={ProfileImage}
              className="img-fluid rounded-start "
              alt="..."
              style={{ objectFit: "contain" }}
            /> */}
            <div class='rounded-gradient-borders'>
              <img
                src={ProfileImage}
                className='img-fluid rounded-start '
                alt='...'
                style={{ objectFit: 'contain' }}
              />
            </div>
          </div>
          <div className='col-md-8'>
            {/* <div className='card-body'>
              <h1 className='card-title fw-bold pb-3 pt-4'>ABOUT ME</h1>

              <h3 className='card-text  text-start  pb-4'>
                🎯 Adaptable Front-end (React/NextJS) developer with 2 years of
                industrial experience in Enterprise-Level Single Page
                Application (SPA) development using React ecosystem.{' '}
              </h3>
              <h3 className='card-text  text-start pb-4'>
                🎯 Experienced in developing front-end systems for big eCommerce
                websites, and admin portals for companies such as e-commerce,
                travel agency, survey agency and real estate in collaboration
                with a cross-functional team.
              </h3>
              <h3 className='card-text  text-start pb-4'>
                🎯 Highly focused on writing quality codes, devising scalable
                patterns, and developing reusable, responsive, and high-quality
                UI components which in turn leads to a scalable, maintainable,
                and viable product.
              </h3>
              <h3 className='card-text  text-start '>
                🎯 Open to learning new skills, making continuous improvements,
                and using the most modern approaches for web applications.
              </h3>
            </div> */}
            <div className='w-full lg:w-1/2 px-6 py-5 text-start'>
              <h3 className='text-black text-2xl font-medium mb-5 capitalize text-center text-sm-start'>
                A Frontend (React JS) Developer
              </h3>
              <p className='text-lg summary lg:text-xl text-secondary mb-4 w-full'>
                Hey there! I&apos;m Tanvir Ahmed, a frontend developer based in
                Dhaka, Bangladesh. I am an adaptable Front-end (React/NextJS)
                developer with{' '}
                <span className='text-dark fw-bold'>
                  2 years of industrial experience
                </span>{' '}
                in Single Page Application (SPA) development using React
                ecosystem. Experienced in developing front-end systems for big
                eCommerce website, and admin portals for companies such as
                e-commerce, travel agency, survey agency, real estate in
                collaboration with a cross-functional team.
                {/* <span className='text-dark font-bold'>@skilzen</span> and{' '}
                <span className='text-dark font-bold'>@codedamn</span> */}
              </p>
            </div>
          </div>
        </div>
      </motion.div>
      {/* experience part */}
      <div className='experience-area'>
        <motion.h2
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 2 }}
          className='text-start fw-bold'
        >
          Experience
        </motion.h2>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 2 }}
          className='line w-80 h-[2px] bg-primary'
        ></motion.div>
        <div className='whitebox w-full h-[80vh] md:h-[60vh] mb-4 py-8'>
          <ExperienceCard
            duration={'February 2023 - PRESENT'}
            position={'Frontend Developer'}
            company={'Openhaus'}
            role={
              'Implementing responsive design techniques to create a consistent user experience on both desktop and mobile devices. Optimising the performance of the front-end code for faster loading times and improved user experience. Collaborating with back-end developers to integrate front-end code with server-side logic. Openhaus pioneers India’s property metaverse, creating a 3D digital twin for seamless decision-making. Manages multiple React projects, integrates a complex video feature with various navigational options and watch time tracking, and implements a customized Google Map with integrated sliders for location filtering. Optimizes performance, maintains the NPM Icon Library, mentors juniors, and ensures platform-wide smooth operation.'
            }
            tech={[
              'React JS',
              'Javascript',
              'Sass',
              'Bootstrap 5',
              'React Bootstrap',
              'Video JS',
              'Google Maps API',
              'Firebase Push Notification',
              'Swiper JS',
              'React Hook Form',
            ]}
          />
          <ExperienceCard
            duration={'December 2021 - December 2022'}
            position={'Junior Frontend Developer'}
            company={'Arbee Solutions'}
            role={
              'Arbree, a UK software consulting firm in Bangladesh, valued my role in enhancing bilingual e-commerce sites with React and Next JS and building a modular B2B OTA portal. In enterprise applications, our team achieved a 67% reduction in development time using Ant Design Pro for an e-commerce admin dashboard, highlighting our collective commitment to efficiency and innovation. Our collaborative efforts signify dedication to excellence.'
            }
            tech={[
              'ReactJS',
              'Next JS',
              'Javascript',
              'Sass',
              'Bootstrap 5',
              'React Bootstrap',
              'Ant Design',
              'Ant D Pro',
              'React Hook Form',
              'React Table',
              'React Query',
            ]}
          />
        </div>
      </div>
    </>
  );
};

export default About;
